<app-modal-component
  [open]="true"
  className="bk-modal--drawer"
  [labelledBy]="titleId"
  [closeOnBackdrop]="true"
  (dismiss)="close()"
>
  <aside class="contactDetailContainer cd" tabindex="-1">
    <!-- Head: who this is -->
    <header class="cd__head">
      <contact-avatar class="cd__avatar" [firstName]="contact?.firstName || ''" [lastName]="contact?.lastName || ''" />
      <div class="cd__who">
        <p class="bk-eyebrow">{{ localContact ? 'Import row' : 'Contact' }}</p>
        <h2 class="bk-heading cd__name" [id]="titleId">{{ name }}</h2>
        <p class="cd__phone">
          {{ phone }}
          @if (phoneIssue) {
            <app-status class="cd__phone-issue" [text]="phoneIssue" status="failed" />
          }
        </p>
      </div>
      <button type="button" class="bk-icon-btn cd__close" aria-label="Close contact panel" (click)="close()">
        <span class="bk-sym" aria-hidden="true">close</span>
      </button>
    </header>

    @if (!localContact) {
      <div class="cd__actions">
        <button type="button" class="bk-btn bk-btn--primary" (click)="sendMessage()">
          <span class="bk-sym" aria-hidden="true">send</span>
          Send message
        </button>
        <button
          *hasPermission="{ category: 'CONTACT_MANAGEMENT', permission: 'edit-contacts' }"
          type="button"
          class="bk-btn bk-btn--ghost"
          (click)="openEditContactModal()"
        >
          <span class="bk-sym" aria-hidden="true">edit</span>
          Edit
        </button>
      </div>
    }

    <div class="cd__body">
      <!-- Details -->
      <section class="cd__section" [attr.aria-labelledby]="titleId + '-details'">
        <h3 class="bk-section-title cd__title" [id]="titleId + '-details'">Details</h3>
        <dl class="bk-kv cd__kv">
          <dt>Email</dt>
          <dd>{{ contact?.emailAddress || '—' }}</dd>
          <dt>Gender</dt>
          <dd>{{ gender }}</dd>
          <dt>Birth date</dt>
          <dd>{{ birthDate }}</dd>
          <dt>Location</dt>
          <dd>{{ place }}</dd>
          @if (!localContact) {
            <dt>Source</dt>
            <dd>{{ source }}</dd>
            <dt>Added</dt>
            <dd>{{ added }}</dd>
          }
        </dl>
      </section>

      <!-- Organizations -->
      <section class="cd__section">
        <h3 class="bk-section-title cd__title">Organizations</h3>
        @if (contactHasOrganizations) {
          <ul class="cd__chips">
            @for (organization of contact?.companyEntities; track $index) {
              <li class="bk-chip">
                <span class="bk-sym" aria-hidden="true">domain</span>
                {{ organization.name }}
              </li>
            }
          </ul>
        } @else {
          <p class="cd__empty">Not in any organization yet.</p>
        }
      </section>

      <!-- Tags -->
      <section class="cd__section">
        <h3 class="bk-section-title cd__title">Tags</h3>
        @if (contactHasTags) {
          <ul class="cd__chips">
            @for (tag of contact?.entityTags; track $index) {
              <li class="bk-chip">
                <span class="bk-sym" aria-hidden="true">sell</span>
                {{ tag.name }}
              </li>
            }
          </ul>
        } @else {
          <p class="cd__empty">No tags yet.</p>
        }
      </section>

      <!-- Recent messages -->
      @if (!localContact) {
        <section class="cd__section">
          <!-- Only the outcome is read out, not every message body. -->
          <p class="bk-sr-only" role="status">{{ messagesStatus }}</p>
          <div class="cd__title-row">
            <h3 class="bk-section-title cd__title">Recent messages</h3>
            @if (messageSummary) {
              <p class="cd__summary">
                {{ sentLabel }}
                @if (messageFailed) {
                  · <span class="cd__failed">{{ failedLabel }}</span>
                }
              </p>
            }
          </div>

          @if (messagesLoading) {
            <div class="cd__skel" aria-hidden="true">
              <span class="bk-skel cd__skel-row"></span>
              <span class="bk-skel cd__skel-row"></span>
              <span class="bk-skel cd__skel-row"></span>
            </div>
          } @else if (messagesError) {
            <div class="cd__state">
              <p class="cd__empty">{{ messagesError }}</p>
              <button type="button" class="bk-more" (click)="retryMessages()">
                Try again
                <span class="bk-sym" aria-hidden="true">refresh</span>
              </button>
            </div>
          } @else if (!messages.length) {
            <p class="cd__empty">No messages sent to this contact yet.</p>
          } @else {
            <ol class="cd__messages">
              @for (line of messages; track line.key) {
                <li class="cd__message">
                  <div class="cd__message-top">
                    <app-status [text]="line.statusText" [status]="line.statusTone" />
                    <span class="cd__when">{{ line.when }}</span>
                  </div>
                  <p class="cd__copy">
                    @if (line.copy) {
                      <bk-sms-text [text]="line.copy" [inline]="true" />
                    } @else {
                      <span class="cd__faint">No message text</span>
                    }
                  </p>
                </li>
              }
            </ol>
          }
        </section>
      }
    </div>
  </aside>
</app-modal-component>

<!-- MODALS -->
@if (showEditContactModal) {
  <edit-contact-modal [selectedContact]="contact" (closeModalEvent)="closeEditContactModal()" />
}
